const uuid = {
  3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
  4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
  5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
  all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
};

function isUUID(str, version = 'all') {
  const pattern = uuid[version];
  return pattern?.test(str);
}

function isFormFieldPattern(value) {
  const pattern = /{{Form\.[^.]*\.Field\.([^}]+)}}/g;
  return pattern.test(value);
}

function isNumeric(value) {
  return /^[+-]?[0-9]+\.?[0-9]*$/.test(value);
}

/**
 * @rule (?=.{8,})          : At least 8 char long
 * @rule (?=.*[a-z])        : At least one lowercase letter
 * @rule (?=.*[A-Z])        : At least one uppercase letter
 * @rule (?=.*\d)           : At least one digit
 * @rule (?=.*[!#*$@%&? "])  : At least one of any char that isn't a letter or digit
 *
 * @link https://stackoverflow.com/questions/48345922/reference-password-validation
 */
function password(str) {
  const pattern = /(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!#*$@%&? "])/;
  return pattern.test(str);
}

/**
 * Build a date regex from a date part and time
 * @param {String} datePart
 * @param {String} timePart
 * @returns {RegExp}
 */
function formatRegExp(datePart, timePart) {
  return timePart ? new RegExp(`^${datePart} ${timePart}$`) : new RegExp(`^${datePart}$`);
}

/**
 * Date formats for the given locale
 * @param {String} separator
 * @param {String} locale
 * @returns
 */
function dateFormats(separator = '/', locale = '') {
  const partDMY = '(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[0-2])/[0-9]{4}';
  const partMDY = '(0[1-9]|1[0-2])/(0[1-9]|[12][0-9]|3[01])/[0-9]{4}';

  const partHm = '(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]';
  const partHms = '(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]';

  const dmy = 'DD/MM/YYYY';
  const mdy = 'MM/DD/YYYY';

  const formats = {
    '/': {
      es: {
        dt: { regexp: formatRegExp(partDMY), format: dmy },
        dt2: { regexp: formatRegExp(partDMY, partHm), format: `${dmy} HH:mm` },
        dt3: { regexp: formatRegExp(partDMY, partHms), format: `${dmy} HH:mm:ss` },
      },
      en: {
        dt: { regexp: formatRegExp(partMDY), format: mdy },
        dt2: { regexp: formatRegExp(partMDY, partHm), format: `${mdy} HH:mm` },
        dt3: { regexp: formatRegExp(partMDY, partHms), format: `${mdy} HH:mm:ss` },
      },
    },
  };

  if (!locale) return formats[separator];
  const prefix = _.split(locale, '-')[0];
  return formats[separator][prefix];
}

function isValidUrl(text) {
  try {
    new URL(text); // Intenta crear un objeto URL
    return true; // Si no lanza un error, es una URL válida
  } catch (err) {
    return false; // Si lanza un error, no es válida
  }
}

export default {
  isUUID,
  password,
  isValidUrl,
  dateFormats,
  isNumeric,
  isFormFieldPattern,
};
